
import { useModalContext } from '@/contexts/ModalContextProvider';
import React, { useContext, useEffect, useState } from 'react';

const useModal = (modalType) => {

  const {setModalType, setModalProps} = useModalContext();

  const showModal = (props) => {
    setModalType(modalType);
    setModalProps(props);
  }

  const hideModal = () => {
    setModalType(null);
    setModalProps({});
  }

  return [showModal, hideModal];
};

export default useModal


export const useHideModal = () => {
  const { setModalType } = useModalContext();

  const hideModal = () => {
    setModalType(null);
  }

  return hideModal;
}
